import React from 'react';

const HowTo = ({ fill }) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M17.3171 6.45084C17.6433 6.53306 17.8879 6.69752 17.9694 7.02642C18.051 7.27311 17.9694 7.60201 17.7248 7.76647L13.974 11.4667L14.8709 16.7292C14.9524 17.0581 14.7894 17.387 14.5447 17.5515C14.3817 17.6337 14.2186 17.7159 14.0555 17.7159H13.6478L9 15.2491L4.35221 17.7159C4.02605 17.8804 3.69989 17.7981 3.45527 17.6337C3.21065 17.4692 3.04757 17.1403 3.12911 16.8114L4.02605 11.5489L0.275198 7.84869C0.0305776 7.68424 -0.0509626 7.35533 0.0305776 7.02642C0.193658 6.69752 0.438279 6.45084 0.764439 6.45084L5.90147 5.62857L8.26614 0.94164C8.51076 0.366052 9.48924 0.366052 9.73386 0.94164L12.0985 5.7108L17.3171 6.45084ZM12.2616 11.3844C12.2616 11.1378 12.3431 10.8911 12.5062 10.6444L15.4417 7.76647L11.4462 7.19088C11.12 7.19088 10.8754 7.02642 10.7939 6.77974L9 3.16176L7.20612 6.86197C7.04304 7.02642 6.79841 7.27311 6.55379 7.27311L2.55832 7.84869L5.49377 10.6444C5.65685 10.8911 5.73839 11.1378 5.73839 11.3844L5.00453 15.4136L8.5923 13.5223C8.83692 13.3579 9.08154 13.3579 9.32616 13.5223L12.9139 15.4136L12.2616 11.3844Z'
        fill={fill}
      />
    </svg>
  );
};

export default HowTo;
